import $ from 'jquery'
import Tool from '../Tool'
import Control from 'ol/control/Control'
import { transform } from 'ol/proj'

/**
 * Coordinate tool
 *
 * @param {Object} config
 * @constructor
 */
export default class Coordinate extends Tool {
  constructor(config) {
    super()
    $.extend(this, config)
    this.ui.iconClass = 'fa fa-map-marker'

    this.$popover = $(`<div style="margin:0">
                        <div class="popover-header">
                          <h3 class="popover-title">Koordinat</h3>
                          <a class="close popover-close"></a>
                        </div>
                        <div style="padding: 5px 10px;">
                          <div style="font-size: 13px; color:#666" class="sweref-title"></div>
                          <div style="display:flex;" class="sweref"></div>
                          <div style="margin-bottom: 10px;" class="sweref-copy-text"></div>
                          <div style="font-size: 13px; color:#666" class="wgs84-title"></div>
                          <div style="display:flex;" class="wgs84"></div>
                          <div class="wgs84-copy-text"></div>
                          <div class="custom-coordinates"></div>
                        </div>
                      </div>`)


    let position = ''
    if(this.config.coordinateTool){
      position = this.config.coordinateTool.position.toLowerCase().trim()
    }
    
    const getPosition = this.getPosition(position)
    const popOverCss = Object.assign({
      backgroundColor: '#fff',
      width: '230px',
      'margin-top': 0,
      position: 'absolute',
      'border-radius': '2px',
      border: '1px solid rgba(0, 0, 0, 0.2)',
      'box-shadow': '0 5px 10px rgb(0 0 0 / 20%)',
      'z-index': 9999,
    }, getPosition) 

    this.$popover.css(popOverCss)

    this.$inDomCrosshair = $(`<div><p style="font-size: 48px;">+</p></div>`)
    this.$inDomCrosshair.css({
      width: '100%',
      height: '100%',
      position: 'absolute',
      'pointer-events': 'none',
      "-webkit-text-stroke-width": "2px",
      "-webkit-text-stroke-color": "#fff",
      left: 0,
      top: '5px',
      display: 'grid',
      'place-content': 'center',
      'z-index': 11,
    })

    this.$swerefTitle = $(`<div>SWEREF 99 TM (E, N)</div>`)
    this.$swerefCoordinates = $(`<div></div>`)
    this.$swerefCopyText = $(`<p style="">Kopierad</p>`)
    this.$swerefCopyButton = $(`<button><i class="fa fa-clipboard"></button>`)

    this.$swerefTitle.appendTo(this.$popover.find('.sweref-title:first'))
    this.$swerefCoordinates.appendTo(this.$popover.find('.sweref:first'))

    this.$swerefCoordinates.text(`..., ...`)

    this.$swerefCopyButton.css({
      'background-color': 'inherit',
      border: 'none',
      display: 'initial',
      'margin-bottom': 0,
    })
    this.$swerefCopyButton.on('click', (e) => {
      const center = this.map.getView().getCenter()
      navigator.clipboard.writeText(center[0] + ',' + center[1])
      this.$swerefCopyText.css({
        margin: 0,
        padding: 0,
        display: 'block',
        color: '#493',
        'font-weight': 600,
      })
      this.$wgs84CopyText.css({ display: 'none' })
    })

    this.$wgs84Title = $(`<div>WGS84 (LAT, LON)</div>`)
    this.$wgs84Coordinates = $(`<div></div>`)
    this.$wgs84CopyButton = $(
      `<button><i class="fa fa-clipboard"></i></button>`
    )
    this.$wgs84CopyText = $(`<p style="">Kopierad</p>`)

    this.$wgs84Title.appendTo(this.$popover.find('.wgs84-title:first'))
    this.$wgs84Coordinates.appendTo(this.$popover.find('.wgs84:first'))

    this.$wgs84Coordinates.text(`..., ...`)

    this.$wgs84CopyButton.css({
      'background-color': 'inherit',
      border: 'none',
      display: 'initial',
      'margin-bottom': 0,
    })
    this.$wgs84CopyButton.on('click', (e) => {
      const center = this.map.getView().getCenter()
      const wgsCenter = transform(
        [center[0], center[1]],
        'EPSG:3006',
        'EPSG:4326'
      )
      navigator.clipboard.writeText(wgsCenter[0] + ',' + wgsCenter[1])
      this.$wgs84CopyText.css({
        margin: 0,
        padding: 0,
        display: 'block',
        color: '#493',
        'font-weight': 600,
      })
      this.$swerefCopyText.css({ display: 'none' })
    })
    this.$inputField = $(`<input placeholder="WGS84 / SWEREF 99TM">`)
    this.$inputGoToCoordsButton = $(
      `<button style="margin-top: 5px;" type="button" class="btn btn-default btn-sm">Gå till koordinat</button>`
    )
    this.$inputError = $(`<div>Dåliga koordinater</div>`)

    this.$inputField.appendTo(this.$popover.find('.custom-coordinates:first'))
    this.$inputGoToCoordsButton.appendTo(
      this.$popover.find('.custom-coordinates:first')
    )
    this.$inputError.appendTo('.custom-coordinates:first')

    const inputCss = {
      'margin-top': '10px',
      border: '1px solid',
      'border-radius': '4px',
      'padding-left': '0.5rem',
      'padding-right': '0.5rem',
      'border-color': 'rgb(200,200,200)',
      width: '100%',
    }
    this.$inputField.css(inputCss)

    this.$inputGoToCoordsButton.on('click', this.goToPosition.bind(this))

    this.control = new Control({
      element: this.$popover.get(0),
    })
    this.controlCrosshair = new Control({
      element: this.$inDomCrosshair.get(0),
    })

    this.map.getView().on('change:center', this.onMove.bind(this))
  }

  getPosition(position) {
    //missing topright due to overlapping gps icon
    switch (position) {
      case 'topmiddle':
        return {
          top: 0,
          // 230px = element width
          'margin-left': 'calc((100vw - 230px)/2)',
        }
      case 'topleft':
        return {
          top: 0,
          left: 0,
        }
      case 'middleleft':
        return {
          left: 0,
          // 212px approx value of elements height
          // -50px to account for top navbar height
          'margin-top': 'calc((100vh - 212px)/2 - 50px)',
        }
      case 'bottomleft':
        return {
          bottom: 0,
          left: 0,
        }
      case 'bottommiddle':
        return {
          bottom: 0,
          // 230px = element width
          'margin-left': 'calc((100vw - 230px)/2)',
        }
      case 'bottomright':
        return {
          bottom: 0,
          right: 0,
        }
      case 'middleright':
        return {
          right: 0,
          // 212px approx value of elements height
          // -50px to account for top navbar height
          'margin-top': 'calc((100vh - 212px)/2 - 50px)',
        }
      default:
        return {
          top: 0,
          // 230px = element width
          'margin-left': 'calc((100vw - 230px)/2)',
        }
    }
  }

  activate() {
    this.map.addControl(this.control)
    this.map.addControl(this.controlCrosshair)
    super.activate()
  }

  deactivate() {
    this.map.removeControl(this.control)
    this.map.removeControl(this.controlCrosshair)
    super.deactivate()
  }

  goToPosition() {
    const regexNumber = /^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$/
    const latLon = this.$inputField.val().split(',')
    const latitude = latLon[0].trim()
    const longitude = latLon[1].trim()

    if (regexNumber.test(latitude) && regexNumber.test(longitude)) {
      const parsedLat = parseFloat(latitude)
      const parsedLon = parseFloat(longitude)

      const checkIfWGS84 = (value) => {
        const split = value.toString().split('.')
        return split[0].length < 4
      }
      if (checkIfWGS84(parsedLon) && checkIfWGS84(parsedLat)) {
        const swerefCenter = transform(
          [parsedLat, parsedLon],
          'EPSG:4326',
          'EPSG:3006'
        )
        this.map.getView().setCenter(swerefCenter)
        this.map.getView().setZoom(12)
      } else if (!checkIfWGS84(parsedLon) && !checkIfWGS84(parsedLat)) {
        this.map.getView().setCenter([parsedLat, parsedLon])
        this.map.getView().setZoom(12)
      } else {
        this.$inputError.appendTo('.custom-coordinates:first')
        this.$inputError.css({ display: 'block', color: 'rgb(200, 100, 80)' })
      }
    } else {
      this.$inputError.appendTo('.custom-coordinates:first')
      this.$inputError.css({ display: 'block', color: 'rgb(200, 100, 80)' })
    }
    this.$inputField.val('')
  }

  onMove() {
    this.center = this.map.getView().getCenter()

    const swerefLongitude = this.center[1]
    const swerefLatitude = this.center[0]

    this.$swerefCoordinates.text(
      `${Math.floor(swerefLatitude)}, ${Math.floor(swerefLongitude)}`
    )

    this.$swerefCopyButton.appendTo(this.$popover.find('.sweref:first'))
    this.$swerefCopyText.appendTo(this.$popover.find('.sweref-copy-text:first'))
    this.$swerefCopyText.css({ display: 'none' })

    this.wgsCenter = transform(
      [swerefLatitude, swerefLongitude],
      'EPSG:3006',
      'EPSG:4326'
    )
    const wgs84Longitude = this.wgsCenter[1]
    const wgs84Latitude = this.wgsCenter[0]

    this.$wgs84Coordinates.text(
      `${Math.floor(wgs84Latitude * 10000000) / 10000000}, ${
        Math.floor(wgs84Longitude * 10000000) / 10000000
      }`
    )
    this.$wgs84CopyButton.appendTo(this.$popover.find('.wgs84:first'))
    this.$wgs84CopyText.appendTo(this.$popover.find('.wgs84-copy-text:first'))
    this.$wgs84CopyText.css({ display: 'none' })

    this.$inputError.appendTo('.custom-coordinates:first')
    this.$inputError.css({ display: 'none' })
  }
}
